const getExtraInvalMessageInfo = (message) => message;

export default getExtraInvalMessageInfo;
